export default class StringUtility {
  static insertAtIndex(oringal, index = 0, appendix) {
    return oringal.slice(0, index) + appendix + oringal.slice(index);
  }
}
